import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LegacyNavigateService} from "../../core/services/legacy-navigate/legacy-navigate.service";
import {DisplayOption, IDataOptions, PivotViewComponent, ToolbarItems} from "@syncfusion/ej2-angular-pivotview";
import {ChartSettings} from "@syncfusion/ej2-pivotview/src/pivotview/model/chartsettings";
import {InternationalizationService} from "../../core/services/internationalization/internationalization.service";

@Component({
  selector: 'sb-slareport-page',
  templateUrl: './slareport-page.component.html',
  styleUrls: ['./slareport-page.component.scss']
})
export class SlaReportPageComponent implements OnInit, OnDestroy {

  @ViewChild('pivotview', { static: false }) public pivotView: PivotViewComponent;

  title = "SLA Report";

  public pivotDataSourceSettings: IDataOptions;

  // Pivot chart controls
  public displayOption = { view: 'Both', primary: 'Table' } as DisplayOption;
  public chartSettings = { enableMultipleAxis: true } as ChartSettings;

  // Toolbar controls
  public toolbarOptions = [
    'Grid',
    'Chart',
    'Export',
    'SubTotal',
    'GrandTotal',
    'FieldList'
  ] as ToolbarItems[];

  constructor(private legacyNavigateService: LegacyNavigateService,
              private i18nService: InternationalizationService) { }

  async ngOnInit() {
    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }
    const errorConsole = document.getElementById("error-console");
    if (errorConsole) {
      errorConsole.innerHTML = "";
    }

    // Mark as angular page
    document.getElementById("detailMain")?.classList?.add("sb-pivotreport-page-content");

    await this.loadData();
  }

  ngOnDestroy(): void {
  }

  private async loadData() {

    this.pivotDataSourceSettings = {

    };

  }

  // Fake button navigation

  buttonLabel(key: string): string {
    return this.i18nService.getMessage(key);
  }

  canGoBack() {
    return this.legacyNavigateService.canGoBack();
  }

  back() {
    this.legacyNavigateService.back();
  }
}
